
/* La pagina entra en fundido de arriba hacia abajo. La clase se pone AQUI,
   antes de que el navegador parsee una sola seccion, para que nada se pinte
   completo y luego se esconda. Sin esta clase no hay animacion: si este
   script no corre, la pagina sale como siempre. */
document.body.classList.add("v-entra");
